import React from "react";
import "./paymentStatWidget.css";

export const PaymentStatWidget = ({ icon: Icon, title, value, subLabel, paid, unpaid, partial, bottomRightLabel, }) => {
  return (
    <div className="paymentStatCard">
      <div className="paymentLeft">
        <div className="paymentHeader">
          <div className="paymentIcon">
            <Icon sx={{ width: '48px', height: '48px', color: '#272727' }} />
          </div>

          <span className="paymentTitle">{title}</span>
        </div>

        <div className="paymentValue">{value}</div>

        <div className="paymentSubLabel">{subLabel}</div>
      </div>

      <div className="paymentDivider"></div>

      <div className="paymentRight">
        <div className="paymentRow">
          <div className="paymentCol">
            <span className="paymentRightLabel">Оплачено</span>
            <div className="paymentRightValue">{paid}</div>
          </div>

          <div className="paymentCol">
            <span className="paymentRightLabel">Не оплачено</span>
            <div className="paymentRightValue">{unpaid}</div>
          </div>
        </div>

        <div className="paymentPartialBlock">
          <span className="paymentRightLabel">Оплачено частично</span>
          <div className="paymentRightValue">{partial}</div>
        </div>

        <div className="paymentBottomText">{bottomRightLabel}</div>
      </div>
    </div>
  );
};
